var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-tag"},[_c('span',{staticClass:"category-tag-dot",style:(("background: " + _vm.color))}),_c('p',[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }